const POPPER_INJECTION_KEY = Symbol("elPopper");
const POPPER_CONTENT_INJECTION_KEY = Symbol("elPopperContent");

export { POPPER_CONTENT_INJECTION_KEY, POPPER_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
